The success result for the `updateWebhookSubscriptionDeliveryConfiguration` mutation.
